import React, { useState, useEffect } from "react";

// @mui material components
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";

const carouselImages = [
  {
    url: "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?q=80&w=1080&fit=crop",
    title: "Authentic Mexican Tacos",
  },
  {
    url: "https://images.unsplash.com/photo-1595295333158-4742f28fbd85?q=80&w=1080&fit=crop",
    title: "Traditional Italian Pasta",
  },
  {
    url: "https://images.unsplash.com/photo-1613514785940-daed07799d9b?q=80&w=1080&fit=crop",
    title: "Mexican Enchiladas",
  },
  {
    url: "https://images.unsplash.com/photo-1555072956-7758afb20e8f?q=80&w=1080&fit=crop",
    title: "Italian Pizza",
  },
  {
    url: "https://images.unsplash.com/photo-1586511925558-a4c6376fe65f?q=80&w=1080&fit=crop",
    title: "Fusion Cuisine",
  },
];

function ImageCarousel() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + carouselImages.length) % carouselImages.length);
  };

  useEffect(() => {
    let interval;
    if (!isHovered) {
      interval = setInterval(() => {
        nextSlide();
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [isHovered]);

  return (
    <MKBox
      position="relative"
      height="500px"
      borderRadius="xl"
      overflow="hidden"
      shadow="lg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        "& img": {
          transition: "transform 0.6s ease-in-out",
        },
        "&:hover img": {
          transform: "scale(1.05)",
        },
      }}
    >
      {carouselImages.map((image, index) => (
        <MKBox
          key={index}
          position="absolute"
          width="100%"
          height="100%"
          sx={{
            opacity: index === currentIndex ? 1 : 0,
            transition: "opacity 0.5s ease-in-out",
          }}
        >
          <MKBox
            component="img"
            src={image.url}
            alt={image.title}
            width="100%"
            height="100%"
            sx={{
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
          <MKBox
            position="absolute"
            bottom={0}
            left={0}
            right={0}
            p={3}
            sx={{
              background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
            }}
          >
            <MKBox
              variant="h4"
              color="white"
              sx={{
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                fontSize: { xs: "1.5rem", md: "2rem" },
              }}
            >
              {image.title}
            </MKBox>
          </MKBox>
        </MKBox>
      ))}

      {!isMobile && (
        <>
          <IconButton
            onClick={prevSlide}
            sx={{
              position: "absolute",
              left: 16,
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(255,255,255,0.9)",
              color: "info.main",
              "&:hover": {
                backgroundColor: "white",
                transform: "translateY(-50%) scale(1.1)",
              },
              transition: "all 0.2s ease-in-out",
              zIndex: 2,
            }}
          >
            <Icon>chevron_left</Icon>
          </IconButton>
          <IconButton
            onClick={nextSlide}
            sx={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(255,255,255,0.9)",
              color: "info.main",
              "&:hover": {
                backgroundColor: "white",
                transform: "translateY(-50%) scale(1.1)",
              },
              transition: "all 0.2s ease-in-out",
              zIndex: 2,
            }}
          >
            <Icon>chevron_right</Icon>
          </IconButton>
        </>
      )}

      <MKBox
        position="absolute"
        bottom={16}
        left={0}
        right={0}
        display="flex"
        justifyContent="center"
        gap={1}
        zIndex={2}
      >
        {carouselImages.map((_, index) => (
          <MKBox
            key={index}
            onClick={() => setCurrentIndex(index)}
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: "white",
              opacity: index === currentIndex ? 1 : 0.5,
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                opacity: 0.8,
                transform: "scale(1.2)",
              },
            }}
          />
        ))}
      </MKBox>
    </MKBox>
  );
}

export default ImageCarousel;
